import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed9c3ae0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form-signin" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-3 fw-normal" }, "Create Package", -1))
const _hoisted_3 = { class: "form-floating" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Package Title", -1))
const _hoisted_5 = { class: "form-floating" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Package Label", -1))
const _hoisted_7 = { class: "form-floating" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Package Detail", -1))
const _hoisted_9 = { class: "form-floating" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Image", -1))
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = { class: "form-floating" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Package Price", -1))
const _hoisted_14 = { class: "form-floating" }
const _hoisted_15 = ["value"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "floatingInput" }, "Country", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Submit", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AdminImageUpload = _resolveComponent("AdminImageUpload")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.package_title) = $event)),
          class: "form-control",
          placeholder: "Package Title",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.package_title]
        ]),
        _hoisted_4
      ]),
      _createElementVNode("div", _hoisted_5, [
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.package_label) = $event)),
          type: "text",
          class: "form-control",
          placeholder: "Package Label",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.package_label]
        ]),
        _hoisted_6
      ]),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.package_detail) = $event)),
          class: "form-control",
          placeholder: "Package Detail",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.package_detail]
        ]),
        _hoisted_8
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.image_url) = $event)),
            class: "form-control",
            placeholder: "File "
          }, null, 512), [
            [_vModelText, $setup.data.image_url]
          ]),
          _createVNode(_component_AdminImageUpload, {
            onUploaded: _cache[4] || (_cache[4] = ($event: any) => ($setup.data.image_url= $event))
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.price) = $event)),
          class: "form-control",
          placeholder: "Package Price",
          required: ""
        }, null, 512), [
          [_vModelText, $setup.data.price]
        ]),
        _hoisted_13
      ]),
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.country_id) = $event)),
          class: "form-control",
          required: ""
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.countries, (country) => {
            return (_openBlock(), _createElementBlock("option", {
              key: country.id,
              value: country.id
            }, _toDisplayString(country.name), 9, _hoisted_15))
          }), 128))
        ], 512), [
          [_vModelSelect, $setup.data.country_id]
        ]),
        _hoisted_16
      ]),
      _hoisted_17
    ], 32)
  ]))
}